import React from "react";
import Activation from "../../../../../assets/Icones/Gestion-utilisateur-ac.png"

class BtnActivation extends React.Component {
    constructor(props) {
      super(props);
      this.btnClickedHandler = this.btnClickedHandler.bind(this);
    }
    btnClickedHandler() {
     this.props.clicked(this.props.value);
    }
    render() {
      return (
        <button className='ButtonGestionUtilisateur' onClick={this.btnClickedHandler}> <img src={Activation} className="IconHome" alt='icone' style={{marginLeft:'-10px'}}/> </button>
      )
    }
  }
export default BtnActivation